module.exports = __webpack_public_path__ + "static/img/Kimberly.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Kimberly.png
// module id = l6Dk
// module chunks = 1